// src/components/pages/discography.js
import React, { useState, useMemo } from 'react';
import { Text } from '../../containers/Language';
import albums from './discography/albums.json';
import '../../styles/discography.css';

export default function Discography() {
  const [selectedAlbum, setSelectedAlbum] = useState(null);

  // ID de la playlist que quieres mostrar permanentemente
  const playlistId = "1OYe2S2dxTFltyHcJkPfe2?si=8faa86d3603d478a"; // Reemplaza esto con el ID de tu playlist

  // Ordenar los álbumes por año (más reciente primero)
  const sortedAlbums = useMemo(() => {
    return [...albums].sort((a, b) => {
      // Convertir los años a números para comparación
      const yearA = parseInt(a.year, 10);
      const yearB = parseInt(b.year, 10);
      return yearB - yearA; // Orden descendente (más reciente primero)
    });
  }, []);

  // Función para abrir/cerrar el reproductor de Spotify
  const toggleSpotifyPlayer = (albumId) => {
    if (selectedAlbum === albumId) {
      setSelectedAlbum(null); // Cierra el reproductor si ya está abierto
    } else {
      setSelectedAlbum(albumId); // Abre el reproductor para el álbum seleccionado
    }
  };

  return (
    <div className='section-container'>
      <div className="discography-container">
        
        {/* Reproductor de Playlist Fijo */}
        <div className="featured-playlist">
          <h2 className="playlist-title"><Text tid="featured_playlist" /></h2>
          <div className="playlist-player">
            <iframe 
              src={`https://open.spotify.com/embed/playlist/${playlistId}?utm_source=generator&theme=0`}
              width="100%" 
              height="352" 
              frameBorder="0" 
              allowFullScreen 
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
              loading="lazy"
            ></iframe>
          </div>
        </div>
        
        <h2 className="section-subtitle"><Text tid="albums" /></h2>
        <div className="albumcontainer">
          {sortedAlbums.map(album => (
            <div key={album.id} className="album-wrapper">
              <div 
                className={`album-card ${selectedAlbum === album.id ? 'selected' : ''}`}
                onClick={() => toggleSpotifyPlayer(album.id)}
              >
                <div className="album-image">
                  <img src={album.img} alt={`${album.band} - ${album.title}`} />
                  <div className="album-overlay">
                    <div className="album-play-icon">
                      {selectedAlbum === album.id ? '✕' : '▶'}
                    </div>
                  </div>
                </div>
                <div className="album-info">
                  <div className="album-band">{album.band}</div>
                  <div className="album-title">{album.title}</div>
                  <div className="album-year">{album.year}</div>
                  {album.composer && <div className="album-role composer"><Text tid="composer" /></div>}
                  {album.instr && <div className="album-role instrumentalist"><Text tid="instrumentalist" /></div>}
                </div>
              </div>
              
              {/* Reproductor de Spotify que se muestra solo para el álbum seleccionado */}
              {selectedAlbum === album.id && album.spotifyId && (
                <div className="spotify-player">
                  <iframe 
                    src={`https://open.spotify.com/embed/album/${album.spotifyId}?utm_source=generator&theme=0`}
                    width="100%" 
                    height="152" 
                    frameBorder="0" 
                    allowFullScreen 
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
                    loading="lazy"
                  ></iframe>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
